import { cn } from "@/utils/ui";

export type RailStep = { id: string; label: string };

/** The four-step spine of the make flow. Same strip on every screen, so the flow reads as one place. */
export function StepRail({
	steps,
	current,
	className,
}: {
	steps: RailStep[];
	current: string;
	className?: string;
}) {
	const idx = Math.max(0, steps.findIndex((s) => s.id === current));
	return (
		<nav aria-label="Progress" data-testid="step-rail" className={cn("flex items-center gap-3", className)}>
			<ol className="flex items-center gap-1.5">
				{steps.map((s, i) => {
					const state = i < idx ? "done" : i === idx ? "current" : "todo";
					return (
						<li key={s.id} className="flex items-center gap-1.5" aria-current={state === "current" ? "step" : undefined}>
							<span
								data-state={state}
								className={cn(
									"h-1.5 rounded-full transition-all",
									state === "current" ? "w-6 bg-primary" : "w-1.5",
									state === "done" && "bg-primary/60",
									state === "todo" && "bg-border-strong",
								)}
							/>
							<span className={cn("text-xs", state === "current" ? "font-medium text-foreground" : "hidden text-muted-foreground sm:inline")}>
								{s.label}
							</span>
						</li>
					);
				})}
			</ol>
			<span className="ml-auto mr-9 text-xs text-muted-foreground tabular-nums sm:hidden">
				{idx + 1} of {steps.length}
			</span>
		</nav>
	);
}

export const MAKE_STEPS: RailStep[] = [
	{ id: "idea", label: "Idea" },
	{ id: "story", label: "Story" },
	{ id: "details", label: "Details" },
	{ id: "cast", label: "Cast" },
];
